import { ReviewCardProps } from 'component/page/detail/Review/Review.selectors';
import { setReviewTranslationState } from 'component/page/detail/store/details';
import { selectReviewTranslationState } from 'component/page/detail/store/detail.selectors';
import { createSelector } from '@reduxjs/toolkit';

interface OwnProps {
    index: number;
    review: ReviewCardProps;
}

interface StateProps {
    translationState: { isLoading: boolean; index: number };
}

export interface DispatchProps {
    onTranslationStart: () => void;
    onTranslationComplete: () => void;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(selectReviewTranslationState, (translationState): StateProps => {
    return {
        translationState: translationState || { isLoading: false, index: -1 },
    };
});

export const mapDispatchToProps = (dispatch: Function, props: OwnProps): DispatchProps => ({
    onTranslationStart: () => {
        dispatch(setReviewTranslationState({ isLoading: true, index: props.index }));
    },
    onTranslationComplete: () => {
        dispatch(setReviewTranslationState({ isLoading: false, index: -1 }));
    },
});
